import { createFileRoute } from "@tanstack/react-router";
import { TruthCompareDetailPage } from "@client/components/truth/truth-compare-detail-page";

export const Route = createFileRoute("/_app/truth/compares/$compareId")({
  component: TruthCompareDetailRoute,
});

function TruthCompareDetailRoute() {
  const { compareId } = Route.useParams();
  return <TruthCompareDetailPage compareId={compareId} />;
}
